export default __webpack_public_path__ + "static/bad-nauheim_bahnhof_west-64886f4bde411efaa764f4676bf67d24.jpg";